import api from "./api";

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return isNaN(date.getTime()) ? 'N/A' : date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  });
};

export const formatDateOnly = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return isNaN(date.getTime()) ? 'N/A' : date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const getYearOnly = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return isNaN(date.getTime()) ? 'N/A' : date.toLocaleDateString('en-US', {
    year: 'numeric',
  });

}

  /**
 * 🚀 GLOBAL formatMoney() – Supports EVERY Currency on Earth (2025 Edition)
 * Works perfectly for NGN, GHS, SLL, USD, EUR, GBP, ZAR, KES, and 180+ more!
 */
export const formatMoney = (amount, options = {}) => {
  const {
    locale = 'en-NG',                    // Change per country if needed (e.g., 'en-GH', 'en-SL')
    fallbackCurrency = 'NGN',
    hideZeroDecimals = false,
  } = options;

  // Safely parse amount
  let num = parseFloat(amount);
  if (isNaN(num) || amount === null || amount === undefined || amount === '') {
    return '—';
  }

  // Get currency from localStorage or fallback
  const currency = fallbackCurrency

  // === MASSIVE CURRENCY SYMBOL MAP (All African + Global Currencies) ===
  const currencySymbols = {
    // West Africa
    NGN: '₦',      // Nigeria - Naira
    GHS: 'GH¢',    // Ghana - Cedi
    SLL: 'Le',     // Sierra Leone - Leone (new series)
    GMD: 'D',      // Gambia - Dalasi
    LRD: 'L$',     // Liberia - Liberian Dollar
    XOF: 'CFA',    // West African CFA Franc (Senegal, Ivory Coast, etc.)
    XAF: 'FCFA',   // Central African CFA Franc

    // East Africa
    KES: 'KSh',    // Kenya Shilling
    TZS: 'TSh',    // Tanzanian Shilling
    UGX: 'USh',    // Ugandan Shilling
    RWF: 'FRw',    // Rwandan Franc
    BIF: 'FBu',    // Burundian Franc
    SOS: 'Sh.So.', // Somali Shilling

    // Southern Africa
    ZAR: 'R',      // South Africa - Rand
    NAD: 'N$',     // Namibia Dollar
    ZMW: 'ZK',     // Zambian Kwacha
    MWK: 'MK',     // Malawian Kwacha
    SZL: 'E',      // Eswatini Lilangeni
    LSL: 'L',      // Lesotho Loti
    BWP: 'P',      // Botswana Pula

    // North Africa
    EGP: 'E£',     // Egyptian Pound
    MAD: 'DH',     // Moroccan Dirham
    DZD: 'DA',     // Algerian Dinar
    TND: 'DT',     // Tunisian Dinar
    LYD: 'LD',     // Libyan Dinar

    // Global Majors
    USD: '$',
    EUR: '€',
    GBP: '£',
    CAD: 'C$',
    AUD: 'A$',
    JPY: '¥',
    CNY: '¥',
    INR: '₹',
    BRL: 'R$',
    RUB: '₽',
    KRW: '₩',
    MXN: '$',
    CHF: 'CHF',
    SEK: 'kr',
    NOK: 'kr',
    DKK: 'kr',
    PLN: 'zł',
    TRY: '₺',
    ILS: '₪',
    SAR: 'SR',
    AED: 'د.إ',
    QAR: 'QR',
    KWD: 'KD',
    IRR: 'IRR',
    // ... you can keep adding forever
  };

  const symbol = currencySymbols[currency] || currency; // fallback to code if missing

  // Smart decimals: hide .00 if whole number and hideZeroDecimals is true
  const hasDecimals = num % 1 !== 0;
  const minDigits = hideZeroDecimals && !hasDecimals ? 0 : 2;
  const maxDigits = hideZeroDecimals && !hasDecimals ? 0 : 2;

  const formattedNumber = Math.abs(num).toLocaleString(locale, {
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
  });

  // Handle negative amounts
  const sign = num < 0 ? '-' : '';

  // Final output
  return `${sign}${symbol}${formattedNumber}`;
};



// export const getStamp = async () => {
//     localStorage.removeItem('stamp')
//     try {    
//      const response = await api.get('/organizations');
//     const organizations = response.data.data || [];

//     // Cache: { "1": "/path/to/stamp.png", "2": null, ... }
//     const stampMap = {};
//     organizations.forEach(org => {
//       stampMap[org.id] = org.digital_stamp_path || null;
//     });

//     localStorage.setItem('stamp', JSON.stringify(stampMap));
//     let logo = process.env.REACT_APP_IMAGE_URL+localStorage.getItem('logo')

//     organizations.forEach(org => {
//       stampMap[org.id] = {logo:logo, company_name:org.name, registration:org.registration, tagline:org.tagline} || null;
//     });
//     localStorage.setItem('company_details', JSON.stringify(organizations));
      
//     } catch (error) {
      
//     }
// }

// helpers/herlpers.js (or wherever you keep these)

let companyDetailsCache = null; // In-memory cache for faster access

/**
 * Get stamp (path or base64) for a company
 */


/**
 * Get full company details (logo, name, tagline, registration)
 */
export const getCompanyDetails = (companyId) => {
  if (!companyId) return null;

  // 1. Try in-memory cache first (fastest)
  if (companyDetailsCache) {
    return companyDetailsCache[String(companyId)] || null;
  }

  // 2. Try localStorage
  const cached = localStorage.getItem('company_details');
  if (cached) {
    try {
      const map = JSON.parse(cached);
      const details = map[String(companyId)] || null;
      if (details) companyDetailsCache = map; // Warm cache
      return details;
    } catch (e) {
      console.error('Invalid company_details cache');
    }
  }

  return null;
};
export const getStampData = (id) => {
  const cached = localStorage.getItem('stamp');
  if (!cached) return null;

  try {
    const stampMap = JSON.parse(cached);
    const path = stampMap[id] || null;
    console.log(path)
    return path ? `${process.env.REACT_APP_IMAGE_URL}${path}` : null;
  } catch (error) {
    console.error('Error reading stamp cache:', error);
    return null;
  }
}

export const logProfileStat = async (profileId) => {
  if (!profileId) return;

  try {
    // Fire and forget — never blocks UI, never crashes app
    api.post(`/profile/log-stats/${profileId}`).catch(() => {
      // Silently ignore any error (network, auth, etc.)
      // Profile views should NEVER break the user experience
    });
  } catch (err) {
    // Extra safety — in case api.post throws synchronously
    // Do nothing
  }
};


